import { render, staticRenderFns } from "./AdminAccount.vue?vue&type=template&id=723c3c67&"
import script from "./AdminAccount.vue?vue&type=script&lang=js&"
export * from "./AdminAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports